(function () {
  'use strict';
  var SEL = '.tolstoy-stories-tiles-container';
  var THRESHOLD = 5;

  function attach(rail) {
    if (!rail || rail.dataset.mkDrag) return;
    rail.dataset.mkDrag = '1';

    var isDown = false, startX = 0, startScroll = 0, moved = false;

    rail.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      isDown = true;
      moved = false;
      startX = e.pageX;
      startScroll = rail.scrollLeft;
    });

    rail.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      if (!moved && Math.abs(dx) > THRESHOLD) {
        moved = true;
        rail.classList.add('mk-tolstoy-dragging');
      }
      if (moved) {
        e.preventDefault();
        rail.scrollLeft = startScroll - dx;
      }
    });

    function end() {
      isDown = false;
      rail.classList.remove('mk-tolstoy-dragging');
    }
    rail.addEventListener('mouseup', end);
    rail.addEventListener('mouseleave', end);

    rail.addEventListener('click', function (e) {
      if (moved) {
        e.stopPropagation();
        e.preventDefault();
        moved = false;
      }
    }, true);
  }

  function scan() {
    var rails = document.querySelectorAll(SEL);
    for (var i = 0; i < rails.length; i++) attach(rails[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
